// ============================================================
// Settings module manifest — R3 retrofit (2026-04-24).
//
// Owns the platform-administration UI: taxonomies (Designations,
// Departments, Component Types), staff logins (username-auth users),
// public-holiday catalog, leave-type seeding, and (future) tenant-
// config UI for enable/disable modules per tenant.
//
// Today the page reads from MANY modules (hr, leave, inventory's
// component-types, users, calendar). It is therefore a meta-module —
// it depends on all of them being present. We declare the explicit
// minimum: hr (taxonomies + employees) and leave (catalog + holidays).
// ============================================================

export default {
  id:          'settings',
  name:        'Settings',
  version:     '1.0.0',
  description: 'Platform administration — taxonomies, staff logins, holidays, tenant config (future).',

  load: () => import('./index.js'),

  routes: [
    {
      id:       'settings',
      label:    'Settings',
      icon:     '⚙',
      section:  'admin',
      sidebarPosition: 20,
      // 2026-05-04 sidebar-leak fix — gate on `settings.read`.
      // Granted to: director ('*'), admin (__ALL_EXCEPT_TENANT_CONFIG__),
      // hr (explicit grant in industry packs for taxonomy + holiday editing).
      // The Rules layer additionally enforces server-side. HR sees Settings
      // because they need to edit Designations / Departments / Holidays;
      // tenant-config + staff-logins remain admin-only via per-action perms
      // checked inside the page (settings.modules.toggle, settings.staff-logins.write).
      visible:  (role, hasPerm) => hasPerm('settings.read'),
      mount:    'mountSettings',
      unmount:  'unmountSettings'
    }
  ],

  // Settings doesn't own collections — it edits collections owned by
  // other modules. Documented here so R6 rule-generation knows this
  // module needs WRITE access to these (admin-only).
  schemas: [],

  permissions: [
    'settings.read',           // see the settings page (director + admin)
    'settings.taxonomies.write',
    'settings.holidays.write',
    'settings.staff-logins.write',
    'settings.modules.toggle'  // future tenant-config UI (R3 follow-up — TODO)
  ],

  dependencies: ['hr', 'leave'],

  fitsIndustries: ['manufacturing', 'trading', 'services', 'retail'],

  functions: [],

  dashboardWidgets: []
};
